const SplashScreen = () => {
  return (
    <>
      <h1>Loading..</h1>
    </>
  );
};

export default SplashScreen;
